import { ManualSectionType } from "./manual-section-type.enum";
import { ManualPageTypeModel } from "./ManualPageTypeModel";

var getPathObj = (section: ManualSectionType, page?: string) => {
    return new ManualPageTypeModel({
        section: section.toString(),
        page: page,
        path: `${section}/${page}`,
    });
};

var ManualPageType: { [key: string]: ManualPageTypeModel } = {
    ApiUsage: getPathObj(ManualSectionType.ApiManual, "api-usage"),
    ApiPowerBIUsage: getPathObj(ManualSectionType.ApiManual, "api-powerbi-usage"),

    RiskDataApi: getPathObj(ManualSectionType.ApiManual, "orm-apis/risks-v1/get-risk-data"),
    RiskDataApiv2: getPathObj(ManualSectionType.ApiManual, "orm-apis/risk-v2/get-risk-data"),
    RiskDataApiv3: getPathObj(ManualSectionType.ApiManual, "orm-apis/risk-v3/get-risk-data"),
    RiskControlDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v1/get-risk-and-control-data",
    ),
    RiskControlDataApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v2/get-risk-and-control-data",
    ),
    RiskControlDataApiv3: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v3/get-risk-and-control-data",
    ),
    RiskControlMoiDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v1/get-risk-control-and-moi-data",
    ),
    RiskControlMoiDataApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v2/get-risk-control-and-moi-data",
    ),
    RiskControlMoiDataApiv3: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v3/get-risk-control-and-moi-data",
    ),
    RiskAssessmentPerOrganizationDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v1/get-risk-assessment-per-organization-data",
    ),
    RiskAssessmentPerOrganizationDataApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v2/get-risk-assessment-per-organization-data",
    ),
    RiskAssessmentPerOrganizationDataApiv3: getPathObj(
        ManualSectionType.ApiManual,
        "orm-apis/risk-v3/get-risk-assessment-per-organization-data",
    ),

    ControlTestInfoApi: getPathObj(ManualSectionType.ApiManual, "controls-apis/get-test-info"),
    ControlUploadSourceDocumentApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/upload-source-document",
    ),
    ControlGenerateSamplesApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/generate-samples",
    ),
    ControlGetSamplesApi: getPathObj(ManualSectionType.ApiManual, "controls-apis/get-samples"),
    ControlSamplesNoEvidenceApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/sample-no-evidence", // No separate right, uses Upload Evidence
    ),
    ControlSamplesUploadEvidenceApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/upload-evidence",
    ),
    ControlTestStepsUploadEvidenceApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/teststeps-upload-evidence", // No separate right, uses Upload Evidence
    ),
    ControlReadyForAssessmentApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/ready-for-assessment",
    ),
    ControlTesterFinalConclusionApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/tester-final-conclusion",
    ),
    ControlSamplesScoreApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/score-samples-and-test-steps",
    ),
    ControlTestStepsScoreApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/score-samples-and-test-steps2", // No separate right, uses Score Samples and Test Steps
    ),
    ControlSampleDocumentsApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/samples-documents", // No separate right, uses Download evidence
    ),
    ControlTeststepDocumentsApi: getPathObj(
        ManualSectionType.ApiManual,
        "controls-apis/teststep-documents", // No separate right, uses Download evidence
    ),

    EventDataApi: getPathObj(ManualSectionType.ApiManual, "ler-apis/get-event-data"),
    EventMoiDataApi: getPathObj(ManualSectionType.ApiManual, "ler-apis/get-event-and-moi-data"),
    DataBreachMoiDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "ler-apis/get-data-breach-and-moi-data",
    ),

    IncidentsCreateApi: getPathObj(ManualSectionType.ApiManual, "incidents-apis/create-incident"),
    IncidentsAddDocumentApi: getPathObj(ManualSectionType.ApiManual, "incidents-apis/add-document-to-incident"),
    IncidentsAddHyperlinkApi: getPathObj(ManualSectionType.ApiManual, "incidents-apis/add-hyperlink-to-incident"),

    FindingReportDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "fr-apis/get-finding-report-and-assessment-data",
    ),

    MoiDataApi: getPathObj(ManualSectionType.ApiManual, "bim-apis/get-moi-data"),
    MoiSummaryDataApi: getPathObj(ManualSectionType.ApiManual, "bim-apis/get-moi-summary-data"),

    KriDataApi: getPathObj(ManualSectionType.ApiManual, "kri-apis/get-kri/kpi-data"),
    KriUploadDataApi: getPathObj(ManualSectionType.ApiManual, "kri-apis/upload-kri/kpi-data"),

    FrmFormsResultsApi: getPathObj(ManualSectionType.ApiManual, "frm-apis/get-forms-results"),
    FrmFormsCreateResultApi: getPathObj(ManualSectionType.ApiManual, "frm-apis/create-form-result"),

    TpCreateApi: getPathObj(ManualSectionType.ApiManual, "tp-apis/create-tp"),
    TpContractCreateApi: getPathObj(ManualSectionType.ApiManual, "tp-apis/create-tp-contract"),

    EC_TPA_RequestExport: getPathObj(
        ManualSectionType.ApiManual,
        "ec-apis/third-party-assurance-requests",
    ),
    EC_TPA_GetResults: getPathObj(ManualSectionType.ApiManual, "ec-apis/tpa-getresults-data"),
    EC_TPA_GetEvidenceDocument: getPathObj(
        ManualSectionType.ApiManual,
        "ec-apis/tpa-getevidencedocument-data",
    ),

    TaskDataApi: getPathObj(ManualSectionType.ApiManual, "tasks-apis/tasks-v1/get-task-data"),
    UploadTaskDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v1/upload-task-data",
    ),
    UpdateTaskDataApi: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v1/update-task-data",
    ),
    UpdateTaskHyperLinkApi: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v1/update-task-hyperlink",
    ),
    UpdateTaskDocumentApi: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v1/update-task-document",
    ),
    TaskDataApiv2: getPathObj(ManualSectionType.ApiManual, "tasks-apis/tasks-v2/get-task-data"),
    UploadTaskDataApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v2/upload-task-data",
    ),
    UpdateTaskDataApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v2/update-task-data",
    ),
    UpdateTaskHyperLinkApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v2/update-task-hyperlink",
    ),
    UpdateTaskDocumentApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v2/update-task-document",
    ),
    MoveToNextWorkflowStateApiv2: getPathObj(
        ManualSectionType.ApiManual,
        "tasks-apis/tasks-v2/move-to-next-workflow-state",
    ),
};

export { ManualPageType };
